import { basePathHelper } from '../base-path.helper';
import NotFoundPage from '../../features/shared/routes/NotFoundPage.tsx';
import { createRouter } from '@tanstack/react-router';
import { routeTree } from '../../routeTree.gen.ts';

export const router = createRouter({
    routeTree,
    basepath: basePathHelper.appPath,
    defaultNotFoundComponent: () => <NotFoundPage />,
});

declare module '@tanstack/react-router' {
    export interface Register {
        router: typeof router
    }
}
